interface CurrentUser {
  id: number;
  name: string;
  email: string;
  account_owner: boolean;
}

const useCurrentUser = (): CurrentUser => {
  return window.currentUser;
};

export default useCurrentUser;
